import { observer } from "mobx-react-lite";
import React, { useEffect } from "react";
import controller from "./controller";
import i from "../../../translations/i";
import { storeLocal } from "../../../helpers/stores";
import { Titles } from "../../../layouts/Titles";
import { Button, Col, Divider, Input, InputNumber, Popover, Row, Select, Space, Table, Tag } from "antd";
import { DeleteOutlined, EditOutlined, InfoCircleOutlined } from "@ant-design/icons";
import { useParams } from "react-router-dom";
import { runInAction } from "mobx";
import { SwitchBlock } from "../../../components/SwitchBlock";

export const AdditionalFieldsSystem = observer(() => {

  useEffect(() => {
    controller.getList()
  }, [])

  const buttons = [
    { title: i.t('def:actions.backList'), href: `/settings/additional_fields`, type: 'dashed' },
  ]

  const columns = [
    { title: 'ID', dataIndex: 'id', key: 'id' },
    { title: i.t('def:Field name'), dataIndex: 'field_name', key: 'field_name' },
    {
      key: 'action',
      render: (text: any, record: any) => (
        <Space size="middle">
          <Button
            type="dashed"
            shape="circle"
            icon={<EditOutlined />}
            href={`/settings/additional_fields_system/${record.id}`}
          />
        </Space>
      )
    }
  ]

  return(
    <>
      <Titles
        title={i.t('def:Additional fields system')}
        buttons={buttons}
      />

      <Table
        columns={columns}
        dataSource={controller.items}
        pagination={false}
      />
    </>
  )
})

export const AdditionalFieldSystem = observer(() => {

  const { id }: any = useParams()

  useEffect(() => {
    controller.getOne(id)
    controller.getList()
  }, [])

  const buttons = [
    { title: i.t('def:actions.backList'), href: `/settings/additional_fields_system`, type: 'dashed' },
    { title: i.t('def:actions.save'), htmlType: `submit`, type: 'primary' }
  ]



  return(
    <>
      <form onSubmit={(e) => controller.save(e)}>
        <Titles
          title={i.t('def:Edit additional field')}
          buttons={buttons}
        />

        <Row gutter={[20, 20]}>
          <Col span={24}>
            <SwitchBlock array={[
              { label: i.t('def:active'), click: (e: any) => controller.item.enabled = e, value: controller.item.enabled }
            ]} />
          </Col>
          <Col span={12}>
            <label>{i.t('def:Field name')}</label>
            <Input
              value={controller.item.field_name}
              onChange={(e: any) => runInAction(() => controller.item.field_name = e.target.value)}
              disabled
            />
          </Col>
          <Col span={12}>
            <label>{i.t('def:Placeholder')}</label>
            <Input
              value={controller.item.placeholder}
              onChange={(e: any) => runInAction(() => controller.item.placeholder = e.target.value)}
            />
          </Col>
          <Col span={24}>
            <SwitchBlock array={[
              { label: i.t('def:Fill register'), click: (e: any) => controller.item.fill_register = e, value: controller.item.fill_register, disabled: controller.item.entity_type !== 'user' },
              { label: i.t('def:Required bonus program'), click: (e: any) => controller.item.required_bonus_program = e, value: controller.item.required_bonus_program },
              { label: i.t('def:Required register'), click: (e: any) => controller.item.required_register = e, value: controller.item.required_register, disabled: controller.item.entity_type !== 'user' },
              { label: i.t('def:Required fill order'), click: (e: any) => controller.item.required_fill_order = e, value: controller.item.required_fill_order },
              { label: i.t('def:Depending'), click: (e: any) => controller.item.depending = e, value: controller.item.depending },
              { label: i.t('def:Only legal'), click: (e: any) => controller.item.only_legal = e, value: controller.item.only_legal },
            ]} />
          </Col>
        </Row>

      </form>
    </>
  )
})